var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13734_38929)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13734_38929)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 34C66 16.8792 52.1208 3 35 3C17.8792 3 4 16.8792 4 34C4 51.1208 17.8792 65 35 65C52.1208 65 66 51.1208 66 34Z",
    fill: "#2D53DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6552 11H18.3448C14.8407 11 12 13.8407 12 17.3448V50.6552C12 54.1593 14.8407 57 18.3448 57H51.6552C55.1593 57 58 54.1593 58 50.6552V17.3448C58 13.8407 55.1593 11 51.6552 11Z",
    fill: "#2D53DA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13734_38929",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 19,
    width: 34,
    height: 30
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9469 19.4733H18.0521V48.526H51.9469V19.4733Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13734_38929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7451 29.3254C49.6223 26.3646 49.2258 24.5492 47.9478 23.2711C46.0952 21.4184 43.1131 21.4184 37.1493 21.4184H32.4051C26.4412 21.4184 23.4593 21.4184 21.6065 23.2711C19.7538 25.1239 19.7538 28.1058 19.7538 34.0697C19.7538 40.0334 19.7538 43.0155 21.6065 44.8681C23.4593 46.7209 26.4412 46.7209 32.4051 46.7209H37.1493C43.1131 46.7209 46.0952 46.7209 47.9478 44.8681C49.2258 43.5903 49.6223 41.7747 49.7451 38.8139",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7451 29.3254C49.6223 26.3646 49.2258 24.5492 47.9478 23.2711C46.0952 21.4184 43.1131 21.4184 37.1493 21.4184H32.4051C26.4412 21.4184 23.4593 21.4184 21.6065 23.2711C19.7538 25.1239 19.7538 28.1058 19.7538 34.0697C19.7538 40.0334 19.7538 43.0155 21.6065 44.8681C23.4593 46.7209 26.4412 46.7209 32.4051 46.7209H37.1493C43.1131 46.7209 46.0952 46.7209 47.9478 44.8681C49.2258 43.5903 49.6223 41.7747 49.7451 38.8139",
    stroke: "white",
    strokeWidth: 0.921952
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5381 29.3269H45.4225C42.6008 29.3269 40.3134 31.4508 40.3134 34.0711C40.3134 36.6914 42.6008 38.8153 45.4225 38.8153H49.5381C49.6701 38.8153 49.7358 38.8153 49.7916 38.812C50.6443 38.76 51.3236 38.1294 51.3795 37.3373C51.3831 37.2856 51.3831 37.2245 51.3831 37.1021V31.0401C51.3831 30.9177 51.3831 30.8565 51.3795 30.8049C51.3236 30.0129 50.6443 29.3822 49.7916 29.3302C49.7358 29.3269 49.6701 29.3269 49.5381 29.3269Z",
    fill: "#FF0016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7427 34.2226L23.3486 25.7975L32.5935 34.2667L24.4165 43.1927L26.7427 34.2226Z",
    fill: "#2D53DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0432 34.0707H45.0582",
    stroke: "white",
    strokeWidth: 1.9361,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13734_38929",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13734_38929"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13734_38929",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13734_38929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr);
export default __webpack_public_path__ + "static/media/HR.6e121513c65f1b440a4d4478645791c1.svg";
export { ForwardRef as ReactComponent };